export default __webpack_public_path__ + "static/media/not-found-photo.b2df4d12.jpg";